import type { SystemDataSequenceId } from "./systemDataSequenceTypes";
import { SystemDataSequenceIds } from "./systemDataSequenceTypes";

export function isSystemDataSequenceId(id: string): id is SystemDataSequenceId {
  return SystemDataSequenceIds.includes(id as SystemDataSequenceId);
}
